import { Endpoints } from '@/core/models/endpoints.interface';

type CustomerTeamTaxDiscountEndpoints = Pick<Endpoints, 'GET_ALL' | 'GET' | 'POST' | 'PUT' | 'DELETE'> & {
   GET_TEAM_TAX_DISCOUNT_TYPES: (...args: Array<any>) => string;
};

export const CUSTOMER_TEAM_TAX_DISCOUNT_ENDPOINTS: CustomerTeamTaxDiscountEndpoints = {
   GET_ALL: (customerId: number) => `/customers/${customerId}/team-tax-discounts`,
   GET: (customerId: number, teamTaxDiscountId: number) => `/customers/${customerId}/team-tax-discounts/${teamTaxDiscountId}`,
   POST: (customerId: number) => `/customers/${customerId}/team-tax-discounts`,
   PUT: (customerId: number, teamTaxDiscountId: number) => `/customers/${customerId}/team-tax-discounts/${teamTaxDiscountId}`,
   DELETE: (customerId: number, teamTaxDiscountId: number) => `/customers/${customerId}/team-tax-discounts/${teamTaxDiscountId}`,
   GET_TEAM_TAX_DISCOUNT_TYPES: (customerId: number) => `/customers/${customerId}/team-tax-discount-types`,
};
